import React from "react";
import { Box, Typography } from "@mui/material";

interface IncidentsSectionHeaderProps {
  statusFilter: string;
  incidentCount: number;
}

const IncidentsSectionHeader: React.FC<IncidentsSectionHeaderProps> = ({
  statusFilter,
  incidentCount,
}) => {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
        {statusFilter === "active" ? "Active incidents" : "Incidents"} (
        {incidentCount})
      </Typography>
      <Typography variant="body2" sx={{ color: "text.secondary", mb: 2 }}>
        {statusFilter === "active"
          ? "Showing stuck, crushed or ongoing tasks that require attention"
          : "Showing all incidents"}
      </Typography>
    </Box>
  );
};

export default IncidentsSectionHeader;
